<template>
    <div class="legal-perform">
        <div class="legal-perform__header">
            <div>
                <span class="label">业务类型</span>
                <el-radio-group v-model="businessType" @change="setConfig('businessType')">
                    <el-radio label="3">运输</el-radio>
                    <el-radio label="4">配送</el-radio>
                    <el-radio label="5">配送（新）</el-radio>
                </el-radio-group>
            </div>
            <div>
                <span class="label">绩效层级</span>
                <el-radio-group v-model="performLevel" @change="setConfig('performLevel')">
                    <el-radio-button
                        v-for="item in performLevelList"
                        :key="item.value"
                        :label="item.value">
                        {{ item.label }}
                    </el-radio-button>
                </el-radio-group>
                <!-- 业务类型 = 运输，才有提示 -->
                <span v-if="businessType === '3' && !$store.state.supplier" class="tips">注意：运输业务类型，系统暂只统计供应商外部客户绩效数据</span>
            </div>
        </div>
        <Paper class="legal-perform">
            <MPanel
                v-if="tableShow"
                ref="tablePage"
                :config="config"
                :totalData="totalData"
                :pageTotal="pageTotal"
                :loading="loading"
                :pageID="config.table.pageId"
                :searchId="config.table.searchId"
                :initSearchInfo="initSearchInfo"
                @viewAppeal-btn="viewAppeal"
                @rejectAppeal-btn="rejectAppeal"
                @viewProject-btn="viewHelpProject"
                @submitProject-btn="submitHelpProject"
                @record-btn="viewRecord"
                @appeal-btn="submitAppeal"
                @performChange-btn="handleAdjust"
                @approve-btn="handleApprove"
                @detail-btn="handleDetail"
                @confirmPerform-btn="confirmPerform"
                @selectChange="selectChange"
                @searchChange="searchChange"
                @pageChange="pageChange"
                @sizeChange="sizeChange">
                <div slot="table-module-btn" v-if="!$store.state.supplier">
                    <div class="icon-button">
                        <el-tooltip class="item" content="导出" placement="bottom">
                            <el-button
                                class="bigData-btn-export"
                                size="mini"
                                icon="el-icon-download"
                                :loading="exportLoading"
                                @click="handleExport"></el-button>
                        </el-tooltip>
                    </div>
                </div>
                <div v-if="!$store.state.supplier" slot="page-module-btn">
                    <el-button
                        v-has="'/legalPerform-90'"
                        :disabled="!checkedData.length"
                        :loading="pushSupplierLoading"
                        class="bigData-btn-push"
                        type="primary"
                        size="mini"
                        @click="pushSupplier">
                        批量推送供应商
                    </el-button>
                    <el-button
                        v-has="'/legalPerform-80'"
                        :disabled="!checkedData.length"
                        :loading="approveSubmitLoading"
                        class="bigData-btn-approve"
                        type="primary"
                        size="mini"
                        @click="performApprove">
                        批量发起绩效审批
                    </el-button>
                    <el-button
                        :disabled="!checkedData.length"
                        :loading="approvePassLoading"
                        class="bigData-btn-approve-pass"
                        type="primary"
                        size="mini"
                        @click="batchApprove">
                        批量审批通过
                    </el-button>
                    <el-button
                        :disabled="!checkedData.length"
                        class="bigData-btn-send"
                        type="primary"
                        size="mini"
                        @click="addArticle">
                        添加发文
                    </el-button>
                    <el-button
                        :loading="rankingLoading"
                        class="bigData-btn-send"
                        type="primary"
                        v-has="'/legalPerform-130'"
                        size="mini"
                        @click="ranking">
                        重新排名
                    </el-button>
                    <el-button
                        :disabled="!checkedData.length"
                        class="bigData-btn-nopush"
                        type="primary"
                        v-has="'/legalPerform-140'"
                        size="mini"
                        @click="onNoPush">
                        无需推送
                    </el-button>
                </div>
            </MPanel>
            <Record ref="rcdRef" />
            <HelpProject @refresh="loadData" ref="helpRef" />
            <PerformAppeal ref="appealRef" @refresh="loadData" />
            <RejectAppeal ref="rejectRef" @refresh="loadData" />
            <AdjustDialog ref="adRef" @success="loadData" />
            <AuditDialog ref="auRef" @refresh="loadData" />
            <NoPushDialog ref="noPushDialog" @refresh="loadData" />
        </Paper>
    </div>
</template>
<script>
import dayjs from 'dayjs'
import MPanel from '@/components/supplierPanel'
import Paper from '@/components/core/paper/Paper'
import { dictWithUrl } from '@/components/lots/api'
import config from './config.js'
import {
    supplierLegalPersonPerformanceList,
    updateSupplierLegalPersonPerformanceStatus,
    exportLegalPersonPerformance,
    recalculateRanking,
} from '../../../api/performManage.js'
import bigDataLog from '@/utils/bigDataLog'
import HelpProject from './components/helpProject.vue'
import PerformAppeal from './components/performAppeal.vue'
import RejectAppeal from './components/rejectAppeal.vue'
import Record from './components/operateRecord.vue'
import AdjustDialog from './components/AdjustDialog.vue'
import AuditDialog from './components/AuditDialog.vue'
import NoPushDialog from './components/NoPushDialog.vue'
import { BUSINESS_TYPE, YES_OR_NO, PERFORM_STATUS, ACTION_TYPE } from '../constant.js'
export default {
    name: 'legalPerform',
    components: { Paper, MPanel, PerformAppeal, RejectAppeal, HelpProject, Record, AdjustDialog, AuditDialog,NoPushDialog },
    data() {
        return {
            rankingLoading: false,
            pushSupplierLoading: false,
            approveSubmitLoading: false,
            approvePassLoading: false,
            tableShow: true,
            businessType: '3',
            performLevel: '1',
            totalData: [],
            pageTotal: 0,
            loading: false,
            pageID: 'legal-perform',
            pageNo: 1,
            searchTerm: {},
            pageSize: 10,
            checkedData: [],
            exportLoading: false,
            dictData: {},
            rowData: {},
            config,
            initSearchInfo: { month: dayjs().subtract((dayjs().date() > 1 || this.$store.state.supplier) ? 1 : 2, 'month').startOf('month').format('YYYY-MM') },
            performLevelList: [
                {label: '分公司', value: '1'},
                {label: '分公司（内外部）', value: '5'},
                {label: '经营中心', value: '6'},
                {label: '经营中心（内外部）', value: '7'},
                {label: '服务平台', value: '2'},
                {label: '服务平台（内外部）', value: '3'},
            ],
        }
    },
    activated(){
        if (this.$store.state.supplier) {
                //LSP
            if (this.$route.query.performanceStatus !== undefined) {
                this.setConfig()
            }
        }
    },
    methods: {
        onNoPush(data){
            if(this.checkedData.length<1){
                const message=`请勾选数据`
                this.$message.warning(message)
                return
            }
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(this.checkedData[0].month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            let params={
                type:'noNeedEdit',
                performLevel:this.performLevel,
                selectList:this.checkedData
            }
         this.$refs.noPushDialog.open(params)

        },
        ranking() {
            this.rankingLoading = true
            recalculateRanking({
                performanceDimension: this.performLevel,
                businessType: this.businessType,
                month: dayjs(this.searchTerm.month).format('YYYY-MM')
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('重新计算提交成功')
                        this.loadData()
                    }
                })
                .finally(() => {
                    this.rankingLoading = false
                })
        },
        pushSupplier() {
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(this.checkedData[0].month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            this.pushSupplierLoading = true
            updateSupplierLegalPersonPerformanceStatus({
                ids: this.checkedData.map(v => v.id),
                operativeFunction: ACTION_TYPE.PUSH,
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.msg || '推送完成')
                        this.loadData()
                    }
                })
                .finally(() => {
                    this.pushSupplierLoading = false
                })
        },
        confirmPerform(row) {
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(row.month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            this.$confirm('是否确认绩效?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                updateSupplierLegalPersonPerformanceStatus({
                    ids: [row.id],
                    operativeFunction: ACTION_TYPE.CONFIRM,
                })
                    .then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('确认绩效完成')
                            this.loadData()
                        }
                    })
                    .finally(() => {
                        this.approveSubmitLoading = false
                    })
            })
        },
        performApprove() {
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(this.checkedData[0].month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            this.approveSubmitLoading = true
            updateSupplierLegalPersonPerformanceStatus({
                ids: this.checkedData.map(v => v.id),
                operativeFunction: ACTION_TYPE.SUBMIT_APPROVE,
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.msg || '发起审批完成')
                        this.loadData()
                    }
                })
                .finally(() => {
                    this.approveSubmitLoading = false
                })
        },
        batchApprove() {
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(this.checkedData[0].month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            // if (this.checkedData.every(v => [PERFORM_STATUS.APPROVING].includes(v.performanceStatus))) {
                this.approvePassLoading = true
                updateSupplierLegalPersonPerformanceStatus({
                    ids: this.checkedData.map(v => v.id),
                    operativeFunction: ACTION_TYPE.APPROVE_PASS,
                })
                    .then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success(res.msg || '审批通过完成')
                            this.loadData()
                        }
                    })
                    .finally(() => {
                        this.approvePassLoading = false
                    })
            // } else {
            //     this.$message.warning('请选择审批中的绩效')
            // }
        },
        addArticle() {
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(this.checkedData[0].month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            let url = ''
            this.$prompt('添加发文链接', '提示', {
                confirmButtonText: '保存',
                cancelButtonText: '取消',
                showInput: true,
                inputPlaceholder: '输入发文链接',
                inputType: 'textarea',
                inputValue: '',
                inputValidator: val => {
                    url = val
                },
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        if (!url.trim()) {
                            return this.$message.warning('请输入发文链接')
                        } else {
                            done()
                        }
                    } else {
                        done()
                    }
                },
            }).then(({ value }) => {
                updateSupplierLegalPersonPerformanceStatus({
                    ids: this.checkedData.map(v => v.id),
                    operativeFunction: ACTION_TYPE.POSTING,
                    postingLink: url,
                }).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.msg || '添加发文完成')
                        this.loadData()
                    }
                })
            })
        },
        viewRecord(row) {
            this.$refs['rcdRef'].init(row.id)
        },
        submitHelpProject(row) {
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(row.month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            this.$refs['helpRef'].init(row.id, false)
        },
        viewHelpProject(row) {
            this.$refs['helpRef'].init(row.id, true)
        },
        submitAppeal(row) {
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(row.month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            this.$refs['appealRef'].init(row.id, false)
        },
        viewAppeal(row) {
            this.$refs['appealRef'].init(row.id, true)
        },
        rejectAppeal(row) {
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(row.month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            this.$refs['rejectRef'].init(row.id)
        },
        selectChange(data) {
            if (data && data.length > 0) {
                this.checkedData = data
            } else {
                this.checkedData = []
            }
        },
        searchChange(data) {
            console.log('searchChange', data)
            this.pageNo = 1
            bigDataLog.sendDetailMessageByKey('bigData-btn-search')
            this.searchTerm = data
            this.loadData()
        },
        pageChange(data) {
            this.pageNo = data
            this.loadData()
        },
        sizeChange(data) {
            this.pageSize = data
            this.loadData()
        },
        // 处理请求参数
        getParams(p) {
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...p,
            }
            if (params.month) {
                params.month = dayjs(params.month).format('YYYY-MM')
            }
            for (const key in params) {
                if (Array.isArray(params[key])) {
                    params[key] = params[key].join(',')
                }
            }
            params.systemFlag = this.$store.state.supplier ? '2' : '1'
            params.performanceDimension = this.performLevel
            params.businessType = this.businessType
            if (this.$store.state.supplier) {
                params.supplierCode = this.$store.state.supplier.supplierCode
            }
            return params
        },
        loadData() {
            const params = this.getParams(this.searchTerm)
            if (!params.month && (!params.supplierCode&&!params.supplierNameCn)) {
                return this.$message.warning('请选择考核月份')
            }
            this.loading = true
            supplierLegalPersonPerformanceList(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.pageTotal = res.data.totalCount || 0
                        res.data.list.forEach(v => {
                            v._countScoreClassName = +v.countScore >= 90 ? 'score-green' : 'score-red'
                            v._timelyShippingRateClassName = v._timelyShippingRateScoreClassName = +v.timelyShippingRateScore >= v.shippingTargetScore ? 'score-green' : 'score-red'
                            v._timelyDeliveryRateClassName = v._timelyDeliveryRateScoreClassName = +v.timelyDeliveryRateScore >= v.arrivalTargetScore ? 'score-green' : 'score-red'
                            v._timelyResponseRateClassName = v._timelyResponseRateScoreClassName = +v.timelyResponseRateScore >= v.receiptTargetScore ? 'score-green' : 'score-red'
                            v._goodsIntegrityRateClassName = v._goodsIntegrityRateScoreClassName = +v.goodsIntegrityRateScore >= v.goodsIntactTargetScore ? 'score-green' : 'score-red'
                            v._onlineRateOfTransportationCapacityClassName = v._onlineRateOfTransportationCapacityScoreClassName = +v.onlineRateOfTransportationCapacityScore >= 0 ? 'score-green' : 'score-red'
                            v._stabilityRateOfTransportationCapacityClassName = v._stabilityRateOfTransportationCapacityScoreClassName = +v.stabilityRateOfTransportationCapacityScore >= 0 ? 'score-green' : 'score-red'
                            v._customerComplaintsScoreClassName = 'score-red'
                            v._customerPraiseScoreClassName = 'score-green'




                            /**
                             * performChange--调整：绩效状态 =【待推送供应商、待复核】
                             * rejectAppeal--驳回申诉：绩效状态 = 【待复核】 && 是否申诉 = 【是】
                             * viewAppeal--查看申诉：是否申诉 = 【是】
                             * submitProject--提交帮扶计划：绩效状态 = 【绩效生效】 && 绩效星级 = 【一星、二星】 && 帮扶计划提交 = 【未提交】
                             * viewProject--查看帮扶计划：帮扶计划提交 = 【已提交】
                             * record--操作记录：LSRM
                             * approve--审批：绩效状态 = 【审批中】&&【绩效审批人配置的人员】
                             * confirmPerform--确认绩效：绩效状态 = 【待供应商确认】&& LSP
                             * appeal--申诉：绩效状态 = 【待供应商确认】&& LSP
                             */
                            let hiddenEvent = []

                            if (v.isAppeal !== YES_OR_NO.YES) {
                                hiddenEvent.push('viewAppeal')
                            }
                            if (this.$store.state.supplier) {
                                if (![PERFORM_STATUS.WAIT_CONFIRM].includes(v.performanceStatus)) {
                                    hiddenEvent.push('confirmPerform')
                                    hiddenEvent.push('appeal')
                                }
                            } else {
                                if (
                                    ![PERFORM_STATUS.WAIT_PUSH, PERFORM_STATUS.WAIT_CHECK].includes(v.performanceStatus)
                                ) {
                                    hiddenEvent.push('performChange')
                                }
                                if (!([PERFORM_STATUS.WAIT_CHECK].includes(v.performanceStatus) && v.isAppeal === YES_OR_NO.YES)) {
                                    hiddenEvent.push('rejectAppeal')
                                }
                                // isDisplayReject为：1不显示【驳回申诉】按钮
                                if(v.isDisplayReject === 1){
                                    hiddenEvent.push('rejectAppeal')
                                }
                                if (
                                    !(
                                        [PERFORM_STATUS.VALID].includes(v.performanceStatus) &&
                                        ['1', '2'].includes(v.performanceStarRating) && [YES_OR_NO.NO].includes(v.isSubmitHelpPlan)
                                    )
                                ) {
                                    hiddenEvent.push('submitProject')
                                }
                                if (![YES_OR_NO.YES].includes(v.isSubmitHelpPlan)) {
                                    hiddenEvent.push('viewProject')
                                }
                                if (!v.isApprovalLimit) {
                                    hiddenEvent.push('approve')
                                }
                            }
                            v.hiddenEvent = hiddenEvent
                        })
                        this.totalData = res.data.list
                        this.selectChange()
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 导出
        handleExport() {
            this.exportLoading = true
            const params = this.getParams(this.searchTerm)
            delete params.pageNo
            delete params.pageSize
            exportLegalPersonPerformance(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.data)
                    }
                })
                .finally(() => {
                    this.exportLoading = false
                })
        },
        setConfig(type) {
            // type: businessType-切换业务类型，performLevel-切换层级，businessType 业务类型，performLevel 层级
            if(type === 'businessType' && this.businessType === '5'){
                //切换业务类型时并且选中配送新，则层级默认选中经营中心
                this.performLevel = '6'
            }
            if (this.$store.state.supplier) {
                //LSP
                const searchTxt = config.lspSearch.searchTxt.filter(v => !v.visible || v.visible.indexOf(this.performLevel) > -1)
                this.config.searchList = {...config.lspSearch, searchTxt}

                if (this.businessType === BUSINESS_TYPE.TRANSPORT) {
                    //运输
                    if (this.performLevel === '1') {
                        //分公司
                        this.config.table = config.lsp.transport.companyTable
                    } else if (this.performLevel === '2') {
                        //服务平台
                        this.config.table = config.lsp.transport.platformTable
                    } else if (this.performLevel === '3') {
                        //服务平台内外部客户
                        this.config.table = config.lsp.transport.clientTable
                    } else if (this.performLevel === '5') {
                        //分公司内外部客户
                        this.config.table = config.lsp.transport.companyClientTable
                    } else if (this.performLevel === '6') {
                        //经营中心
                        this.config.table = config.lsp.transport.businessTable
                    }else if (this.performLevel === '7') {
                        //经营中心内外部
                        this.config.table = config.lsp.transport.businessClientTable
                    }
                }else if(this.businessType === '5'){
                    //配送（新）
                    this.config.searchList = {...this.config.searchList, searchTxt: [...this.config.searchList.searchTxt,...config['delivery_newSearch'].searchTxt.filter(v => !v.visible || v.visible.indexOf(this.performLevel) > -1)]}
                    if (this.performLevel === '1') {
                        //分公司
                        this.config.table = config.lsp.delivery_new.companyTable
                    } else if (this.performLevel === '2') {
                        //服务平台
                        this.config.table = config.lsp.delivery_new.platformTable
                    } else if (this.performLevel === '3') {
                        //内外部客户
                        this.config.table = config.lsp.delivery_new.clientTable
                    } else if (this.performLevel === '5') {
                        //分公司内外部客户
                        this.config.table = config.lsp.delivery_new.companyClientTable
                    } else if (this.performLevel === '6') {
                        //经营中心
                        this.config.table = config.lsp.delivery_new.businessTable
                    }else if (this.performLevel === '7') {
                        //经营中心内外部
                        this.config.table = config.lsp.delivery_new.businessClientTable
                    }
                }
                else {
                    //配送
                    if (this.performLevel === '1') {
                        //分公司
                        this.config.table = config.lsp.delivery.companyTable
                    } else if (this.performLevel === '2') {
                        //服务平台
                        this.config.table = config.lsp.delivery.platformTable
                    } else if (this.performLevel === '3') {
                        //内外部客户
                        this.config.table = config.lsp.delivery.clientTable
                    } else if (this.performLevel === '5') {
                        //分公司内外部客户
                        this.config.table = config.lsp.delivery.companyClientTable
                    } else if (this.performLevel === '6') {
                        //经营中心
                        this.config.table = config.lsp.delivery.businessTable
                    }else if (this.performLevel === '7') {
                        //经营中心内外部
                        this.config.table = config.lsp.delivery.businessClientTable
                    }
                }
            } else {
                //LSRM
                if (this.businessType === BUSINESS_TYPE.DELIVERY) {
                    //配送
                    if (this.performLevel === '1') {
                        //分公司
                        this.config.searchList = config.companySearch
                        this.config.table = config.lsrm.delivery.companyTable
                    } else if (this.performLevel === '2') {
                        //服务平台
                        this.config.searchList = config.platformSearch
                        this.config.table = config.lsrm.delivery.platformTable
                    } else if (this.performLevel === '3') {
                        //内外部客户
                        this.config.searchList = config.clientSearch
                        this.config.table = config.lsrm.delivery.clientTable
                    } else if (this.performLevel === '5') {
                        //分公司内外部客户
                        this.config.searchList = config.companyClientSearch
                        this.config.table = config.lsrm.delivery.companyClientTable
                    } else if (this.performLevel === '6') {
                        //经营中心
                        this.config.searchList = config.businessSearch
                        this.config.table = config.lsrm.delivery.businessTable
                    }else if (this.performLevel === '7') {
                        //经营中心内外部
                        this.config.searchList = config.businessClientSearch
                        this.config.table = config.lsrm.delivery.businessClientTable
                    }
                } else if(this.businessType === '5'){
                    //配送（新）
                    if (this.performLevel === '1') {
                        //分公司
                        this.config.searchList = config.companySearch
                        this.config.table = config.lsrm.delivery_new.companyTable
                    } else if (this.performLevel === '2') {
                        //服务平台
                        this.config.searchList = config.platformSearch
                        this.config.table = config.lsrm.delivery_new.platformTable
                    } else if (this.performLevel === '3') {
                        //内外部客户
                        this.config.searchList = config.clientSearch
                        this.config.table = config.lsrm.delivery_new.clientTable
                    } else if (this.performLevel === '5') {
                        //分公司内外部客户
                        this.config.searchList = config.companyClientSearch
                        this.config.table = config.lsrm.delivery_new.companyClientTable
                    } else if (this.performLevel === '6') {
                        //经营中心
                        this.config.searchList = config.businessSearch
                        this.config.table = config.lsrm.delivery_new.businessTable
                    }else if (this.performLevel === '7') {
                        //经营中心内外部
                        this.config.searchList = config.businessClientSearch
                        this.config.table = config.lsrm.delivery_new.businessClientTable
                    }
                    this.config.searchList = {...this.config.searchList, searchTxt: [...this.config.searchList.searchTxt,...config['delivery_newSearch'].searchTxt.filter(v => !v.visible || v.visible.indexOf(this.performLevel) > -1)]}
                }
                else {
                    //运输
                    if (this.performLevel === '1') {
                        //分公司
                        this.config.searchList = config.companySearch
                        this.config.table = config.lsrm.transport.companyTable
                    } else if (this.performLevel === '2') {
                        //服务平台
                        this.config.searchList = config.platformSearch
                        this.config.table = config.lsrm.transport.platformTable
                    } else if (this.performLevel === '3') {
                        //内外部客户
                        this.config.searchList = config.clientSearch
                        this.config.table = config.lsrm.transport.clientTable
                    } else if (this.performLevel === '5') {
                        //分公司内外部客户
                        this.config.searchList = config.companyClientSearch
                        this.config.table = config.lsrm.transport.companyClientTable
                    } else if (this.performLevel === '6') {
                        //经营中心
                        this.config.searchList = config.businessSearch
                        this.config.table = config.lsrm.transport.businessTable
                    }else if (this.performLevel === '7') {
                        //经营中心内外部
                        this.config.searchList = config.businessClientSearch
                        this.config.table = config.lsrm.transport.businessClientTable
                    }
                }
            }
            this.tableShow = false
            this.pageNo = 1
            this.$nextTick(() => {
                this.tableShow = true
                if (this.$store.state.supplier) {
                    //LSP
                    if (this.$route.query.performanceStatus !== undefined) {
                        let performanceStatus = this.$route.query.performanceStatus;
                        this.initSearchInfo.performanceStatus = performanceStatus
                    }
                }
                this.searchTerm = this.initSearchInfo
                this.loadData()
            })
        },
        handleAdjust(row) {
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(row.month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            this.$refs.adRef.open(row)
        },
        handleApprove(row) {
            //运输&配送新在当月3号以后才能操作上个月的数据
            if(['3', '5'].includes(this.businessType) && dayjs().diff(dayjs(row.month).endOf('month'), 'day') < (this.dictData['PERFORM_OPERATION_DATE'].configDate - 1)){
                return this.$message.warning(`当月${this.dictData['PERFORM_OPERATION_DATE'].configDate}号及以后才能操作上个月的数据`)
            }
            this.$refs.auRef.open(row)
        },
        //详情
        handleDetail(row) {
            this.$refs.adRef.open(row, true)
        },
    },
    mounted() {
        this.setConfig()
        dictWithUrl('PERFORMANCE_DIMENSION_TYPE,PERFORM_OPERATION_DATE').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
                // this.loadData()
            }
        })
    },
}
</script>
<style lang="less">
.legal-perform {
    flex: 1;
    min-width: 1100px;
    &__header {
        padding: 16px;
        margin: 10px;
        min-width: 1000px;
        background: #fff;
        border-radius: 4px;

        > div:first-child {
            margin-bottom: 10px;
        }

        .label {
            margin-right: 10px;
            font-size: 12px;
            color: #1c2631;
        }
    }
    .tips{
        color: #aaa;
        margin-left: 10px;
        font-size: 12px;
    }

    #mPane3 {
        display: flex;
        height: 100%;
        flex-direction: column;

        .otp-table {
            flex: 1;
        }

        .el-table {
            min-height: initial;
        }
        .page-text {
            > div {
                height: auto;
            }
        }
        // min-height: calc(100vh - 206px);
    }

    .row-bg{
        .el-col-12 {
            width: 45%;
        // width: calc(100% - 850px);
        }
        .page-text {
            &.el-col-12 {
                width: 55%;
               div:first-child{
                width: 96px;
               }
                div:last-child{
                    margin-right: 140px !important;
                    .el-button{
                        margin-bottom: 5px;
                        // border: 1px solid red;
                    }
                 
                  
                }
                // width: 840px !important;
            
                
            }
        }
    }
    }
    .score-green{
        color: green;
    }
    .score-red{
        color: red;
    }
    
    .bidding-procurement-plan {
    min-width: 1100px;
    #mPane3 {
        .page-text {
            > div {
                height: auto;
            }
        }
    }
    .row-bg{
        .el-col-12 {
            width: 45%;
        // width: calc(100% - 850px);
        }
        .page-text {
            &.el-col-12 {
                width: 55%;
               div:first-child{
                width: 96px;
               }
                div:last-child{
                    margin-right: 140px !important;
                    .el-button{
                        margin-bottom: 5px;
                        // border: 1px solid red;
                    }
                 
                  
                }
                // width: 840px !important;
            
                
            }
        }
    }
    @media screen and (min-width : 1770px){
            .legal-perform {
            .row-bg{
                .el-col-12 {
                    width: 35%;
                }
                .page-text {
                    &.el-col-12 {
                        width: 65%;
                        div:last-child{
                            .el-button{
                                margin-bottom: 5px;
                            }
                        
                        }
                        
                    }
                }
            }


        } 
    }

}




</style>